// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_StatsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/anticipations/stats/{subaccount_id}
 *
 * Returns the anticipation aggregates for a subaccount as a single typed
 * object with two nested blobs:
 *
 *   - counts ← per-status row counts (total / pending / credited / denied),
 *              all native ints from count_all_results().
 *   - totals ← monetary aggregates: anticipated and fee sums in cents (int)
 *              plus their reais display values (float = cents / 100).
 *
 * @see anticipations.php::stats()
 */
import type { SubaccountsAnticipations_StatsCountsRow } from './SubaccountsAnticipations_StatsCountsRow'
import type { SubaccountsAnticipations_StatsTotalsRow } from './SubaccountsAnticipations_StatsTotalsRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsAnticipations_StatsResponseDados {
counts: SubaccountsAnticipations_StatsCountsRow
totals: SubaccountsAnticipations_StatsTotalsRow
}

export type SubaccountsAnticipations_StatsResponse = ApiResponse<SubaccountsAnticipations_StatsResponseDados>;

registerResponseContract('SubaccountsAnticipations_StatsResponse', {
  counts: {
    type: 'object',
    required: true,
    fields: {
      total:    { type: 'number',  required: true },
      pending:  { type: 'number',  required: true },
      credited: { type: 'number',  required: true },
      denied:   { type: 'number',  required: true },
    },
  },
  totals: {
    type: 'object',
    required: true,
    fields: {
      anticipated_cents:   { type: 'number',  required: true },
      anticipated_display: { type: 'number',  required: true },
      fees_cents:          { type: 'number',  required: true },
      fees_display:        { type: 'number',  required: true },
    },
  },
})
